import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Container, Modal, Navbar, Nav, NavDropdown, Row } from "react-bootstrap";
//import { GlobeIcon, PersonIcon, SignOutIcon } from "@primer/octicons-react";
import { GlobeIcon, PersonIcon } from "@primer/octicons-react";
import { MdClose, /*MdNotificationsNone*/ } from "react-icons/md";
import { BiHome } from "react-icons/bi";
import { axiosAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from "react-i18next";
import classes from './AdminPages.module.css';
import { UserContext } from "../UserContext";
import configInfo from '../config/config.json';
//import logoImage from "../images/CompanyLogo.png";
//import profilePhoto from "../images/ProfilePhoto.png";

import './Topbar.css';

const Topbar = (props) => {

  const { i18n, t } = useTranslation(["common"]);
  const { user, setUser } = useContext(UserContext);

  const [showProdInfo, setShowProdInfo] = useState(false);

  const navigate = useNavigate();

  const handleLogout = () => {

    axiosAuth_IDENT_MGMT_API.post('logout', {"origin": "IGC_ADMIN_PORTAL"})
    .then(function (response) {

      setUser(null);
      sessionStorage.setItem("accessToken", "");

      navigate("/Login/" + i18n.language);
    })
    .catch(function (error) {
      // ##### NEED TO DECIDE WHAT TO DO #####
    });

  };

  const handleLangSelection = (newLang) => {
    i18n.changeLanguage(newLang);
  };

  const handleLogoClick = () => {
    if (!user) {
      navigate("/");
    } else {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Console'
        }
      });
    }
  };

  const handleUserProfile = () => {
    navigate("/AdminHome/UserProfile");
  };

  const lngDropdownTitle = (
    <span>
      <span>
        <GlobeIcon size={16} />
      </span>
      <span style={{ marginLeft: "10px", marginTop: "10px" }}>
        {t("I18N_Lng_Select")}
      </span>
    </span>
  );


  const userDropdownTitle = (
    <span>
{/*
      <span>
        <img src={profilePhoto} width='24px' alt={'ProfilePhoto'} style={{border:'0', borderRadius:'13px'}} />
      </span>
*/}
      <span>
        <PersonIcon size={16} />
      </span>

      <span style={{ marginLeft: "10px", marginTop: "10px" }}>
        {user && user.userInfo ? user.userInfo.username : null}
      </span>
    </span>
  );

  // For open on hover for Language Selector dropdown
  const [openLngDropdown, setOpenLngDropdown] = useState(false);
  const showLngDropdown = (e) => {
      setOpenLngDropdown(!openLngDropdown);
  }
  const hideLngDropdown = (e) => {
      setOpenLngDropdown(false);
  }

  // For open on hover for Username dropdown
  const [openUserDropdown, setOpenUserDropdown] = useState(false);
  const showUserDropdown = (e) => {
      setOpenUserDropdown(!openUserDropdown);
  }
  const hideUserDropdown = (e) => {
      setOpenUserDropdown(false);
  }


  const handleClickProdInfo = (e) => {
    e.preventDefault();

    setShowProdInfo(true);
  }

  const handleHideProdInfo = (e) => {
    e.preventDefault();

    setShowProdInfo(false);
  }

  return (
    <>
      <Navbar
        className="navbar-igc"
        variant="dark"
        expand="sm"
        style={{ fontSize: "13px", borderRadius: '5px', padding: '1px' }}
      >
        <Container
          style={{
            marginLeft: "0px",
            paddingLeft: "15px",
            paddingRight: "15px",
            maxWidth: "2500px",
            fontWeight: '300'
          }}
        >
{/*
          {user ?
            <Navbar.Brand href="">
              <span onClick={handleToggleSidebar} style={{cursor:'pointer'}}> <BiMenu size={16} /> </span>
            </Navbar.Brand>
          : null}
*/}

          <Navbar.Brand href="">
            <div style={{marginTop:"-5px"}}> {/* ##### Hack to vertically line up with the rest of the top menu bar items */}
{/*
              <img
                src={logoImage}
                width={26}
                style={{marginTop:"2px", borderRadius:"5px", cursor:"pointer"}}
                alt={"SHKP"}
                onClick={handleLogoClick}
              />
*/}
              <span onClick={handleLogoClick} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(250,250,250)' }}>
                <BiHome size={18} />
              </span>
              <span style={{marginLeft: '30px', fontSize:'13px', fontWeight:'500', cursor: 'pointer'}} onClick={handleClickProdInfo}>
                 BuildingOS Admin Portal
              </span>
            </div>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
{/*
              {!user ? (
                <li>
                  <Nav.Link href="/">{t("I18N_Home")}</Nav.Link>
                </li>
              ) : null}
              {!user ? (
                <li>
                  <Nav.Link href="/AboutUs">{t("I18N_About_Us")}</Nav.Link>
                </li>
              ) : null}
              {!user ? (
                <li>
                  <Nav.Link href="/ContactUs">{t("I18N_Contact_Us")}</Nav.Link>
                </li>
              ) : null}
*/}
            </Nav>

{/* ##### Future enhancement #####
            <Nav>
              {user && (user.userInfo) && (user.userInfo.notifCount) && (user.userInfo.notifCount > 0) ? (
                <div style={{display:'flex', color:'white', border:'0 solid rgb(134, 133, 133)', borderColor:'white', borderRadius:'3px', fontSize:"12px"}}>
                  <MdNotificationsNone style={{color:'#ccc'}} size={16} />
                  <span style={{color:'#ccc', marginRight:'40px'}}>{user.userInfo.notifCount > 10 ? '10+' : user.userInfo.notifCount}</span>
                </div>
              ) : null}
            </Nav>
*/}

            <Nav>
              <NavDropdown
                title={lngDropdownTitle}
                id="lng-dropdown"
                menuVariant="dark"
                style={{padding:"0", minWidth:'100px', fontSize:'12px'}}
/* ### Comment out since cannot fix the bug: when the cursor is in-between the title and dropdown body, they popup disappears
                show={openLngDropdown}
*/
                onMouseEnter={showLngDropdown}
                onMouseLeave={hideLngDropdown}
              >
                {i18n.language !== "en" ? (
                  <NavDropdown.Item
                    as="button"
                    onClick={() => handleLangSelection("en")}
                    style={{fontSize:"13px", fontWeight:'200'}}
                  >
                    EN
                  </NavDropdown.Item>
                ) : null}
                { configInfo.langSupported.zh_HK && (i18n.language !== "zh_HK") ? (
                  <NavDropdown.Item
                    as="button"
                    onClick={() => handleLangSelection("zh_HK")}
                    style={{fontSize:"13px", fontWeight:'200'}}
                  >
                    繁中
                  </NavDropdown.Item>
                ) : null}
                {configInfo.langSupported.zh_CN && (i18n.language !== "zh_CN") ? (
                  <NavDropdown.Item
                    as="button"
                    onClick={() => handleLangSelection("zh_CN")}
                    style={{fontSize:"13px", fontWeight:'200'}}
                  >
                    简中
                  </NavDropdown.Item>
                ) : null}
              </NavDropdown>
            </Nav>

            <Nav>
              {!user ? (
                <Nav.Link href={"/Login/" + i18n.language}>{t("I18N_Login")}</Nav.Link>
              ) : null}
            </Nav>

            {user ? (
              <Nav>
                <NavDropdown
                  title={userDropdownTitle}
                  id="user-dropdown"
                  menuVariant="dark"
                  style={{padding:"0", minWidth:"100px", fontSize:"12px"}}
/* ### Comment out since cannot fix the bug: when the cursor is in-between the title and dropdown body, they popup disappears
                  show={openUserDropdown}
*/
                  onMouseEnter={showUserDropdown}
                  onMouseLeave={hideUserDropdown}
                >
                  { configInfo.uiConfig.menuShown.TOPBAR_USER_PROFILE && configInfo.uiConfig.menuShown.TOPBAR_USER_PROFILE ?
                    <NavDropdown.Item
                      as="button"
                      onClick={handleUserProfile}
                      style={{fontSize:"13px", fontWeight:'200'}}
                    >
                      {t("I18N_User_profile")}
                    </NavDropdown.Item>
                  : null
                  }

                  <NavDropdown.Item
                    as="button"
                    onClick={handleLogout}
                    style={{fontSize:"13px", fontWeight:'200'}}
                  >
                    {t("I18N_Logout")}
                  </NavDropdown.Item>

                </NavDropdown>
              </Nav>
            ) : null}

{/*
            <Nav>
              {user ? (
                <Nav.Link to="" onClick={handleLogout}>
                  <SignOutIcon className="none" size={16} />
                </Nav.Link>
              ) : null}
            </Nav>
*/}

          </Navbar.Collapse>
        </Container>
      </Navbar>


      <Modal className="version-dialog" show={showProdInfo} onHide={handleHideProdInfo} style={{ marginTop:'20px', marginLeft:'70px', width:'300px', height:'150px' }} centered backdrop="static">
        <Modal.Body>
          <Container>
            <form>
            <Row>
              <Col sm="10"  className={classes.admin_pages__field_valu}>
                <span>BuildingOS Admin Portal</span>
              </Col>
              <Col sm="2" className={classes.admin_pages__field_label} style={{ paddingRight:'0px'}} >
                <MdClose style={{ color:'#333', float:'right', cursor:'pointer'}} size={16} onClick={handleHideProdInfo}/>
              </Col>
            </Row>
            <Row style={{ marginTop: '5px', marginRight: '0px', paddingRight: '0px' }}>
              <Col sm="4"  className={classes.admin_pages__field_label}>
                <span>{t("I18N_Version")}: </span>
              </Col>
              <Col sm="8" className={classes.admin_pages__field_value}>
                <span>{configInfo.versionInfo.version}</span>
              </Col>
            </Row>
            <Row style={{ marginRight: '0px', paddingRight: '0px' }}>
              <Col sm="4"  className={classes.admin_pages__field_label}>
                <span>{t("I18N_Time_built")}: </span>
              </Col>
              <Col sm="8" className={classes.admin_pages__field_value}>
                <span>{configInfo.versionInfo.timeBuilt}</span>
              </Col>
            </Row>
            </form>
          </Container>
        </Modal.Body>
      </Modal>

    </>
  );
};

export default Topbar;
